import { getGraphqlUrl } from '../../apollo';
import { ContinueToBookErrorStatus } from '../../contracts/types';
export function selectRoomMetric(tripStateId, graphqlErrors) {
    var _a;
    let recordCode;
    if (graphqlErrors) {
        const error = graphqlErrors.find((err) => Object.prototype.hasOwnProperty.call(err.extensions, 'code'));
        if (error) {
            recordCode = (_a = error === null || error === void 0 ? void 0 : error.extensions.code) !== null && _a !== void 0 ? _a : ContinueToBookErrorStatus.OtherError;
        }
    }
    fetch(`${getGraphqlUrl()}/recordSelectRoomStatus`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            query: `
                mutation RecordSelectRoom($tripStateId: ID!, $result: ContinueToBookErrorStatus!) {
                    recordSelectRoomStatus(tripStateId: $tripStateId, result: $result)
                }
            `,
            variables: {
                tripStateId,
                result: recordCode !== null && recordCode !== void 0 ? recordCode : ContinueToBookErrorStatus.Success,
            },
        }),
    }).catch((error) => {
        console.error('Error in selectRoomMetric', error);
    });
}
